const cache = new Map<string, Intl.DateTimeFormat>();

// Building an Intl.DateTimeFormat is the expensive part of formatting a date, and tables format hundreds.
export const getDateTimeFormat = (locale: string, options: Intl.DateTimeFormatOptions) => {
	const key = `${locale}|${JSON.stringify(options)}`;
	let format = cache.get(key);
	if (!format) {
		format = new Intl.DateTimeFormat(locale, options);
		cache.set(key, format);
	}
	return format;
};
